// API Configuration and Endpoints
// Auto-detect environment and set appropriate API URL
const getApiBaseUrl = () => {
  // Check if we're in development (localhost) or production
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('localhost');
  
  // Check if we're on the production domain
  const isProduction = window.location.hostname.includes('cloudlab.com.np') ||
                      window.location.hostname.includes('muaccount');
  
  // Priority: localStorage > auto-detection > default
  const savedUrl = localStorage.getItem('apiBaseUrl');
  
  if (savedUrl) {
    return savedUrl;
  }
  
  if (isLocalhost) {
    return 'http://localhost:8000';
  }
  
  if (isProduction) {
    return 'https://muaccount.api.cloudlab.com.np';
  }
  
  // Default fallback
  return 'http://localhost:8000';
};

const API_BASE_URL = getApiBaseUrl();

// Authentication Endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login/`,
  LOGOUT: `${API_BASE_URL}/auth/logout/`,
  REGISTER: `${API_BASE_URL}/auth/register/`,
  PROFILE: `${API_BASE_URL}/auth/profile/`,
};

// Capital Expenditure Endpoints
export const CAPITAL_EXPENDITURE_ENDPOINTS = {
  LIST: `${API_BASE_URL}/capital-expenditure/`,
  CREATE: `${API_BASE_URL}/capital-expenditure/`,
  DETAIL: (id) => `${API_BASE_URL}/capital-expenditure/${id}/`,
  UPDATE: (id) => `${API_BASE_URL}/capital-expenditure/${id}/`,
  DELETE: (id) => `${API_BASE_URL}/capital-expenditure/${id}/`,
  BY_FISCAL_YEAR: (fiscalYear) => `${API_BASE_URL}/capital-expenditure/fiscal-year/${fiscalYear}/`,
};

// Institution Endpoints
export const INSTITUTION_ENDPOINTS = {
  LIST: `${API_BASE_URL}/institutions/`,
  CREATE: `${API_BASE_URL}/institutions/`,
  DETAIL: (id) => `${API_BASE_URL}/institutions/${id}/`,
  UPDATE: (id) => `${API_BASE_URL}/institutions/${id}/`,
  DELETE: (id) => `${API_BASE_URL}/institutions/${id}/`,
};

// Fiscal Year Endpoints
export const FISCAL_YEAR_ENDPOINTS = {
  LIST: `${API_BASE_URL}/fiscal-years/`,
  CREATE: `${API_BASE_URL}/fiscal-years/`,
  DETAIL: (id) => `${API_BASE_URL}/fiscal-years/${id}/`,
  UPDATE: (id) => `${API_BASE_URL}/fiscal-years/${id}/`,
  DELETE: (id) => `${API_BASE_URL}/fiscal-years/${id}/`,
};

// Office Endpoints
export const OFFICE_ENDPOINTS = {
  LIST: `${API_BASE_URL}/offices/`,
  CREATE: `${API_BASE_URL}/offices/`,
  DETAIL: (id) => `${API_BASE_URL}/offices/${id}/`,
  UPDATE: (id) => `${API_BASE_URL}/offices/${id}/`,
  DELETE: (id) => `${API_BASE_URL}/offices/${id}/`,
};

// Master Expenditure Items Endpoints
export const MASTER_EXPENDITURE_ITEMS_ENDPOINTS = {
  LIST: `${API_BASE_URL}/master-expenditure-items/`,
  CREATE: `${API_BASE_URL}/master-expenditure-items/`,
  DETAIL: (id) => `${API_BASE_URL}/master-expenditure-items/${id}/`,
  UPDATE: (id) => `${API_BASE_URL}/master-expenditure-items/${id}/`,
  DELETE: (id) => `${API_BASE_URL}/master-expenditure-items/${id}/`,
};

// API Helper Functions
export const API_HELPERS = {
  getAuthHeaders: () => {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Token ${token}` })
    };
  },
  
  handleResponse: async (response) => {
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  },
  
  // Function to manually override API URL (for testing purposes)
  setApiUrl: (url) => {
    localStorage.setItem('apiBaseUrl', url);
    // Reload the page to apply the new URL
    window.location.reload();
  },
  
  // Function to reset to auto-detection
  resetApiUrl: () => {
    localStorage.removeItem('apiBaseUrl');
    window.location.reload();
  },
  
  // Function to get current API URL
  getCurrentApiUrl: () => {
    return API_BASE_URL;
  }
};

// Export API_BASE_URL for use in other components
export { API_BASE_URL };
